var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { WikiPageType } from '../../../../defs/schema-static';
import { MILESTONE_SCHEMA_ROUTE } from '../../../../defs/schema/public/Milestones';
import { HttpRestService } from '../shared/http-rest/http-rest.service';
import { MomentService } from '../shared/moment/moment.service';
var DashboardReminderComponent = (function () {
    function DashboardReminderComponent(httpRest, momentService, window) {
        this.httpRest = httpRest;
        this.momentService = momentService;
        this.window = window;
        this.WikiPageType = WikiPageType;
        this.showModal = false;
    }
    DashboardReminderComponent.prototype.show = function () {
        var _this = this;
        this.showModal = true;
        setTimeout(function () {
            _this.startTime = _this.momentService.moment(_this.meeting.beginDate).format('HH:mm');
            _this.endTime = _this.momentService.moment(_this.meeting.endDate).format('HH:mm');
        }, 50);
    };
    DashboardReminderComponent.prototype.valid = function () {
        var _this = this;
        var begin = this.momentService.moment(this.meeting.beginDate).format('YYYY-MM-DD');
        var end = this.momentService.moment(this.meeting.endDate).format('YYYY-MM-DD');
        this.meeting.beginDate = this.momentService.moment(begin + "T" + this.startTime);
        this.meeting.endDate = this.momentService.moment(end + "T" + this.endTime);
        this.httpRest
            .post(MILESTONE_SCHEMA_ROUTE, {
            id: this.meeting.id,
            beginDate: this.meeting.beginDate && this.momentService.moment(this.meeting.beginDate).utc(),
            endDate: this.meeting.endDate && this.momentService.moment(this.meeting.endDate).utc(),
        })
            .subscribe(function () {
            _this.goTo();
            _this.showModal = false;
        });
    };
    DashboardReminderComponent.prototype.validate = function () {
        return !(!this.momentService.moment(this.startTime, 'HH:mm', true).isValid() ||
            !this.momentService.moment(this.endTime, 'HH:mm', true).isValid());
    };
    DashboardReminderComponent.prototype.goTo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                args = "/wiki/edit?meetingId=" + this.meeting.id + "&type=" + WikiPageType.MEETING_NOTE;
                args += this.meeting.clientId ? "&client=" + this.meeting.clientId : '';
                args += this.meeting.projectId ? "&project=" + this.meeting.projectId : '';
                this.window.open(args);
                return [2];
            });
        });
    };
    return DashboardReminderComponent;
}());
export { DashboardReminderComponent };
